import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { createApiDocsConfigFactory } from '../features/api-docs';
import { createSnowplowApiFactory } from '../features/analytics-snowplow';
import { createVersionCheckFetchApiFactory } from '../features/version-check';
import {
  HealthServiceApi,
  HealthServiceClient,
} from '@appfolio/backstage-plugin-health-common';
import {
  TechRadarClient,
  techRadarIndexApiRef,
} from '@appfolio/backstage-plugin-tech-radar';

export const healthServiceApiRef = createApiRef<HealthServiceApi>({
  id: 'root.health.service',
});

const apis: AnyApiFactory[] = [
  createVersionCheckFetchApiFactory(),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: techRadarApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new TechRadarClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: techRadarIndexApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new TechRadarClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: healthServiceApiRef,
    deps: { configApi: configApiRef, fetchApi: fetchApiRef },
    factory: ({ configApi, fetchApi }) =>
      new HealthServiceClient({ configApi, fetchApi }),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiDocsConfigFactory(),
  createSnowplowApiFactory(),
];

export default apis;
